/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：遷移サービス
 *
 * 作成者：2022/2/22 ノア）黄
 * 最終修正者：2022/2/22 ノア）黄
 *
 */

/**
 * 遷移サービス
 *
 * @class
 */
class MoveService {
  /**
   * ログアウト前の処理
   *
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async beforeLogout(): Promise<void> {}

  /**
   * 遷移前の処理
   *
   * @param {any} next 遷移処理
   * @returns {void}
   */
  // eslint-disable-next-line
  beforePageChange: ((next: any) => Promise<void> | undefined) | undefined
}

export const moveService = new MoveService()
